import { createApp } from 'vue'
import App from '@/App.vue'

import { router } from '@/router'
import { store } from '@/store/create-store'

import { vMaska } from 'maska/vue'
import {
  PortalPlugin,
  VueGlobalPropertiesPlugin,
  AmplifyPlugin,
  SentryPlugin
} from '@/plugins'

import '@/assets/styles/main.scss'

const app = createApp(App)

app
  .use(store)
  .use(router)
  .use(PortalPlugin)
  .use(VueGlobalPropertiesPlugin)
  .use(AmplifyPlugin)
  .use(SentryPlugin)
  .directive('maska', vMaska)

router.isReady().then(() => {
  app.mount('#app')
})

export {
  app
}
